export const integrations = [
  {
    name: 'LangChain',
    package: '@memorygateway/langchain',
    description: 'MemoryGatewayMemory class — drop-in LangChain memory with one import.',
    href: '/docs/langchain',
  },
  {
    name: 'CrewAI',
    package: '@memorygateway/crewai',
    description: 'CrewAI agent integration for multi-agent memory sharing.',
    href: '/docs/crewai',
  },
  {
    name: 'AutoGen',
    package: '@memorygateway/autogen',
    description: 'Microsoft AutoGen adapter for agent-to-agent memory sync.',
    href: '/docs/autogen',
  },
  {
    name: 'Custom REST',
    package: '@memorygateway/rest',
    description: 'HTTP API for any agent framework — JSON over HTTPS.',
    href: '/docs/api',
  },
  {
    name: 'MCP Protocol',
    package: '@modelcontextprotocol',
    description: 'MCP-compatible for interoperability with MCP-native tools.',
    href: '/docs/mcp',
  },
];
